import { Controller } from "@hotwired/stimulus"
import { destroy } from "@rails/request.js"

export default class extends Controller {
  static values = { url: String }

  declare urlValue: string

  async dismiss() {
    await destroy(this.urlValue)
    this.element.remove()
  }
}
